import { EstateType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useCallback } from "react";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import useAppDispatch from "@/core/helpers/useAppDispatch.ts";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { Tab } from "@/domains/estate/constants/tab.ts";
import { EstateInfo, setEstateInfo, setTabs } from "@/domains/estate/slice";
import toast from "@/domains/toasts/helpers/toast.ts";

export default () => {
  const dispatch = useAppDispatch();

  const getEstateGuestInfo = async (estateId: number): Promise<EstateInfo> => {
    const response = await EstateMpProvider.getGuestInfo(estateId);

    if (response instanceof RpcMpProviderFailedResponse) {
      console.error(response);
      toast.error("Не удалось получить информацию об имуществе");
      return null;
    }

    const {
      id,
      entity,
      isResident,
      feeBalance,
      owner,
      address,
      level,
      price,
      totalFee,
      vehicles,
      isLocked,
      tenants,
      baseFee,
    } = response.data;

    return {
      id,
      complexId: entity.type === EstateType.Apartment ? entity.content.complexId : null,
      type: entity.type,
      feeBalance,
      address: `${address.streetName} ${address.index} ${entity.type === EstateType.Apartment ? entity.content.room : ""}`,
      totalFee,
      vehicles,
      isLocked,
      isResident,
      isSale: !owner,
      level,
      owner,
      price,
      tenants,
      maxFee: 0,
      baseFee,
    };
  };

  const getEstateInfo = async (estateId: number): Promise<EstateInfo> => {
    const response = await EstateMpProvider.getDetails(estateId);

    if (response instanceof RpcMpProviderFailedResponse) {
      console.error(response);
      toast.error("Не удалось получить информацию об имуществе");
      return null;
    }

    const {
      id,
      entity,
      owner,
      feeBalance,
      address,
      level,
      price,
      maxFeeBalance,
      baseFee,
      totalFee,
      vehicles,
      isLocked,
      hasResidence,
      tenants,
      permissions,
    } = response.data;

    return {
      id,
      complexId: entity.type === EstateType.Apartment ? entity.content.complexId : null,
      type: entity.type,
      feeBalance,
      address: `${address.streetName} ${address.index} ${entity.type === EstateType.Apartment ? entity.content.room : ""}`,
      totalFee,
      vehicles,
      isLocked,
      isResident: hasResidence,
      isSale: !owner,
      level,
      owner,
      price,
      tenants,
      maxFee: maxFeeBalance,
      baseFee,
      permissions,
    };
  };

  const loadInfo = useCallback(
    async (estateId: number): Promise<void> => {
      const info = await getEstateInfo(estateId);

      const tabs: [Tab, boolean][] = [
        [Tab.Info, true],
        [Tab.Tenants, true],
        [Tab.Fee, true],
        [Tab.Garage, info.permissions.garage],
        [Tab.Walls, info.permissions.upgrade],
        [Tab.Furniture, info.permissions.upgrade],
        [Tab.Improvements, info.permissions.upgrade],
        [Tab.History, true],
      ];

      dispatch(setTabs(tabs.filter((tab) => tab[1]).map((v) => v[0])));
      dispatch(setEstateInfo(info));
    },
    [dispatch],
  );

  return {
    loadInfo,
    getEstateInfo,
    getEstateGuestInfo,
  };
};
